export default {
  personnel: {
    search: {
      startTime: '开始时间',
      endTime: '结束时间',
      dataState: '数据状态',
      company: '公司',
      personnelInformation: '人员信息',
    },
    table: {
      index: '序号',
      personNo: '人员标识号',
      Name: '姓名',
      company: '公司',
      department: '部门',
      companyDepartment: '公司/部门',
      phone: '移动电话',
      email: '邮箱',
      dataState: '数据状态',
      creatTime: '创建时间',
      companyRules: '此行公司不能为空',
      departmentRules: '此行部门不能为空',
      tableTitle: '请填写表格数据',
      chockedLows: '您还没选择想要删除的数据',
      deletSuccess: '删除成功!',
      deletFalse: '已取消删除!',
      revokeFalse: '已取消撤回!',
      companyDepartmentRules: '公司部门不能为空',
      sortNo: '序列不能为空',
    },
    button: {
      add: '创建',
      import: '导入',
      export: '导出',
      prohibit: '禁用',
      Enable: '启用',
      deletChange: '垃圾桶',
      getUp: '放弃',
      addCost: '增加费用行项目',
      deleteCost: '删除',
    },
    addpersonnel: {
      personNo: '人员标识号',
      personSex: '性别',
      personName: '姓名',
      companyInformation: '公司信息',
      phoneWays: '联系方式',
      bankInformation: '银行信息',
      email: '电子邮箱',
      adminInformation: '个人信息',
      personNational: '国籍',
      changeTitle: '请选择',
      personId: '身份证号',
      inputTitle: '请输入信息',
      passportId: '护照号',
      personBankAccount: '银行账号',
      personDepositBank: '开户行',
      personAccountName: '开户名',
      personBankReservation: '银行预留电话',
      bankCardFrontPhotos: '银行卡正面',
      bankCardBackPhotos: '银行卡反面',
      pushMapLinkList: '系统映射表',
      viewHistory: '历史记录',
      pushMapLink: '推送以获取映射关系',
      save: '保存',
      sumbit: '提交',
      Prohibit: '禁用',
      Enable: '启用',
      modify: '修改',
      middleClass: '中台类别',
      middleClassValue: '中台类别值',
      mappingSystem: '映射系统',
      mappingClass: '映射类别',
      mappingClassValue: '映射类别值',
      viewPeople: '查看人员主数据',
      personnel: '人员主数据',
      creatPersonnel: '新建人员主数据',
      editPersonnel: '修改人员主数据',
      upLodeTitle: '上传头像图片只能是JPG或PNG格式!',
      upLodeImgSizeTitle: '上传头像图片大小不能超过1MB!',
      dataStatus: '当前状态',
      updateReason: '修改原因',
      time: '时间',
      changeInformation: '变更信息',
      boy: '男',
      girl: '女',
      oaId: 'OAID',
    },
    rules: {
      checkIdCard: '身份证号格式错误',
      emailChecked: '电子邮箱不合规范',
      phoneChecked: '移动电话不符合规范',
      checkIdpassportNo: '护照号不合规范',
      checkBankAccount: '银行账号不合规范',
      writeName: '请输入姓名',
      writePhone: '请输入移动电话',
      writeEamil: '请输入电子邮箱',
      writeCountry: '请选择国籍',
      writeIdcard: '请输入身份证号',
      writePassportNo: '请输入护照',
      writeBankAccount: '请输入银行账号',
      writeDepositBank: '请输入开户行',
      writeAccountName: '请输入开户名',
      writeBankReservation: '请输入银行预留电话',
      writebankCardFrontPhotos: '请上传银行卡',
      writeIdCardNumber: '请输入18位身份证号',
      checkPhoneBank: '请输入手机号或固定电话',
      updateReason: '请输入修改原因',
      oaIdReason: '请输入OAID',
      personNoReason: '请输入人员标识号',
    },
    dataStateList: {
      submit: '已提交',
      Approval: '审批中',
      Effective: '已生效',
      disabled: '已禁用',
      Rejected: '已驳回',
      draft: '草稿',
    },
    routerTitle: {
      createPersonnelMaster: '创建人员主数据',
      companyMaintain: '公司维护',
      departmentMaintain: '部门维护',
      waitForLine: '序列优先级',
      writeNumber: '请输0-0999之间的数字',
      companyTheSame: '同一公司下选择了相同部门',
      WriteOverPersonInformation: '请完善公司信息和个人信息',
    },
    wrongTitle: {
      changeData: '请选择要操作的数据',
      effectiveStatic: '存在状态不是已生效的数据',
      disabledStatic: '存在状态不是已禁用的数据',
      canNot: '当前状态无法提交',
      canDoIt: '当前状态不可进行该操作',
      gitUpSucess: '放弃成功!',
    },
  },
};
